export default "https://legacy.eskolare-development.com/images/logout.png";